import { Component, Input } from '@angular/core';
import { DiaryFormElement } from "../../../../../core/models/trial-diary-form/diary-form-element.model";
import { DiaryFormOption } from "../../../../../core/models/trial-diary-form/diary-form-option.model";
import { NgFor } from "@angular/common";
import { ButtonComponent } from "../../../../../shared/button/button.component";
import {
  DiaryFormOptionTranslation
} from "../../../../../core/models/trial-diary-form/diary-form-option-translation.model";

@Component({
  selector: 'app-element-option-list',
  standalone: true,
  imports: [NgFor, ButtonComponent],
  templateUrl: './element-option-list.component.html',
  styleUrl: './element-option-list.component.scss'
})
export class ElementOptionListComponent {
  @Input() element: DiaryFormElement;
  @Input() culture: string = 'en';
  @Input() editable: boolean = true;

  getOptionText(option: DiaryFormOption): string {
    if (this.culture === 'en')
      return option.text;

    const translation = option.translations.find(t => t.culture === this.culture);
    if (translation)
      return translation.text;

    return '';
  }

  addOption(): void {
    const newOption = new DiaryFormOption({
      text: '',
      orderIndex: this.element.options.length
    });
    this.element.options.push(newOption);
    this.updateOptionOrderIndexes();
  }

  optionIsEditable(option: DiaryFormOption) {
    if (this.culture !== 'en') {
      let translation = option.translations.find(t => t.culture === this.culture);
      if (!translation || (translation && translation.id === null) || (translation && (translation.text === null || translation.text === '')))
        return true;
    }

    return this.editable;
  }

  optionIsRemovable(option: DiaryFormOption) {
    return this.editable;
  }

  removeOption(idx: number): void {
    this.element.options.splice(idx, 1);
    this.updateOptionOrderIndexes();
  }

  moveOptionUp(idx: number): void {
    if (idx <= 0) return;
    [this.element.options[idx - 1], this.element.options[idx]] = [this.element.options[idx], this.element.options[idx - 1]];
    this.updateOptionOrderIndexes();
  }

  moveOptionDown(idx: number): void {
    if (idx >= this.element.options.length - 1) return;
    [this.element.options[idx], this.element.options[idx + 1]] = [this.element.options[idx + 1], this.element.options[idx]];
    this.updateOptionOrderIndexes();
  }

  updateOptionOrderIndexes(): void {
    this.element.options.forEach((option, i) => option.orderIndex = i);
  }

  onOptionTextChange(idx: number, event: Event): void {
    if (this.culture === 'en') {
      this.element.options[idx].text = (event.target as HTMLInputElement).value;
      return;
    }

    let translation = this.element.options[idx].translations.find(t => t.culture === this.culture);
    if (translation) {
      translation.text = (event.target as HTMLInputElement).value;
    } else {
      this.element.options[idx].translations.push(new DiaryFormOptionTranslation({
        culture: this.culture,
        text: (event.target as HTMLInputElement).value
      }));
    }
  }
}

